import React from "react";
import { Link } from "react-router-dom";
import LogoIcon from "../../assets/icons/LogoIcon";
import "./Footer.scss";

const Footer = () => {
  return (
    <div className="main-grid-app-footer"> 
      <div className="footer-logo">
      <a href="https://solunion.com/" target="blank"><LogoIcon width={124} heigth={24} fill="white" className="logo" /></a>   
        <span className="version-text row align-self-end text-white mt-1">© eGrade, v-{process.env.REACT_APP_VERSION}</span>
      </div>
     
     
      <section className="text-start">
        <div className="row">
          <ul className="col-xs-1 list-group list-group-horizontal-xl list-group-horizontal-md ">
            <li className="text-start">
              <Link to="/privacity" className="text-white">Política de privacidad</Link>
            </li>
            <li className="text-start">
              <Link to="/legal" className="text-white">Aviso legal</Link>
            </li>
            <li className="text-start">
              <Link to="/contact" className="text-white">Contacto</Link>
            </li>
            <li className="text-star">
              <Link to="/cookies" className="text-white">Navegación con cookies</Link>
            </li>
          </ul>
        </div>
        
      </section>
    </div>
  );
};

export default Footer;
